import { DataSourceExecutionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutResponsibilityProspectConversionRateReport } from './autogen/AutogenLayoutResponsibilityProspectConversionRateReport';

/**
 * Prospect Conversion Rate Responsibility Report
 * PBI: 352253
 *
 * Extends Prospect Conversion Rate Report with responsibility hierarchy filtering.
 * Includes dynamic page break behavior based on Group By selection.
 */
export class ResponsibilityProspectConversionRateReport extends AutogenLayoutResponsibilityProspectConversionRateReport {

    onLoad() {
        // Set default values
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.checkboxIncludeMarketingPlan.checked = false;
    }

    /**
     * Handles changes to the Include switch.
     * Updates the customer field caption and lookup model based on selection.
     */
    includeChanged() {
        // When checked (right position) = Customers and Prospects, When unchecked (left position) = Customers Only
        const isCustomersAndProspects = this.switchInclude.checked;
        
        if (isCustomersAndProspects) {
            // Customers and Prospects
            this.excludabletextboxCustomerId.textbox.caption = "Customer(s) / Prospect(s)";
            this.excludabletextboxCustomerId.textbox.lookupModel = "lme/crm/prospect";
            this.excludabletextboxCustomerId.textbox.lookupModelLayout = "lme/crm/ProspectLookup";
            this.excludabletextboxCustomerId.textbox.lookupModelDisplayField = "descr"
        } else {
            // Customers Only
            this.excludabletextboxCustomerId.textbox.caption = "Customer(s)";
            this.excludabletextboxCustomerId.textbox.lookupModel = "lme/ar/customer";
            this.excludabletextboxCustomerId.textbox.lookupModelLayout = "lme/ar/CustomerLookup";
            this.excludabletextboxCustomerId.textbox.lookupModelDisplayField ="name"
        }
        
        // Clear the field when switching modes
        this.excludabletextboxCustomerId.textbox.clear();
    }

    /**
     * Handles hierarchy level changes.
     * Enables/disables hierarchy code field based on whether a level is selected.
     */
    private textboxHierarchyLevelOnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxHierarchyCode.clear();
        this.textboxHierarchyCode.enabled = event.hasSelection();
    }

    /**
     * Filters hierarchy codes based on selected hierarchy level.
     */
    private textboxHierarchyCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.hierarchy_level = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }

    excludabletextboxOperationsUserBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        // Filter to only show User ('U') or Employee ('E') web user types
        event.filter.web_user_type = "U || E";
    }

    textboxGroupByOnChange(): void {
        const groupByValue = this.textboxGroupBy.selectedItem?.displayValue;

        if (groupByValue && groupByValue !== "None") {
            this.checkboxPageBreak.enabled = true;
        } else {
            this.checkboxPageBreak.checked = false;
            this.checkboxPageBreak.enabled = false;
        }
    }

    /** This is an event handler for the beforeExecution event of sourceResponsibilityPendingActivitiesReport. */
    sourceResponsibilityPendingActivitiesReportBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.hierarchy_level_number = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }
}
